import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3b4d252&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c3b4d252&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b4d252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3b4d252')) {
      api.createRecord('c3b4d252', component.options)
    } else {
      api.reload('c3b4d252', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c3b4d252&scoped=true", function () {
      api.rerender('c3b4d252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/technology/AiWriter/index.vue"
export default component.exports